import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { apiRequest, isApiError } from "@/shared/api";
import type { ApiError } from "@/shared/api";
import {
  normalizeAuthResponse,
  type NormalizedAuthResponse,
} from "./normalize-auth-response";

export type RegisterPayload = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  referralCode?: string;
};

export type RegisterResponse = NormalizedAuthResponse;

const registerRequest = (payload: RegisterPayload) => ({
  url: "/auth/register",
  method: "post",
  data: payload,
});

export const register = async (
  payload: RegisterPayload
): Promise<RegisterResponse> => {
  const response = await apiRequest<unknown>(registerRequest(payload));
  return normalizeAuthResponse(response, payload.email, {
    requireToken: false,
  });
};

export const useRegister = (
  options?: UseMutationOptions<RegisterResponse, ApiError, RegisterPayload>
) =>
  useMutation<RegisterResponse, ApiError, RegisterPayload>({
    mutationFn: register,
    ...options,
    onError: (error, variables, onMutateResult, context) => {
      if (!isApiError(error)) {
        console.error("[auth] Unexpected registration error", error);
      }

      options?.onError?.(error, variables, onMutateResult, context);
    },
  });
